<template>
	<ui-sidebar-float :overlay-close="true"
		:load="optionsLoading"
		:loadText="loadText"
		icon="far fa-cog"
		ref="form-tracker-config"
		name="form-tracker-config"
		title="Configurações"
		text="Configure a entrada de leads que virá do seu formulário.">
		<form>
			<div v-show="message" class="message mb-15" v-html="message"></div>
			<section data-content data-title="Mapear Campos" data-id="fields-mapping">
				<section class="sidebar-content">
					<h2>1 - Campos Principais</h2>
					<ui-select-2 v-model="form.map_fields.customer.name"
						:data="options"
						multiple
						return-value="value"
						label="Nome do Cliente:"
						size="md" />

					<ui-select-2 v-model="form.map_fields.customer.email"
						:data="options"
						multiple
						return-value="value"
						label="E-mail:"
						size="md" />

					<ui-select-2 v-model="form.map_fields.customer.phone"
						:data="options"
						multiple
						return-value="value"
						label="Telefone:"
						size="md" />

					<ui-select-2 v-model="form.map_fields.customer.mobile"
						:data="options"
						multiple
						return-value="value"
						label="Celular:"
						size="md" />

					<ui-select-2 v-model="form.map_fields.customer.cpf"
						:data="options"
						multiple
						return-value="value"
						label="CPF:"
						size="md" />

					<ui-select-2 v-model="form.map_fields.deal.observations"
						:data="options"
						multiple
						return-value="value"
						label="Observações:"
						size="md" />

					<ui-select-2 v-model="form.map_fields.customer.message"
						:data="options"
						multiple
						return-value="value"
						label="Mensagem:"
						size="md" />
				</section>

				<section class="sidebar-content">
					<h2>2 - Campos Personalizados</h2>
					<section class="ui-no-items" v-show="!customFieldsComputed.length">
						<div>Nenhum campo personalizado foi adicionado.</div>
						<div>
							<button type="button" @click="addFields()">
								<i class="fal fa-plus"></i>
							</button>
						</div>
					</section>
					<ui-popup name="add-fields" 
						title="Adicionar campo Personalizado"
						text="Selecione o campo desejado.">

							<ui-select-2
								v-model="fieldGroupSelected"
								:loading="fieldGroupLoading"
								:data="fieldGroupOptions"
								label="Grupo de Campos:"
								item-label="name"
								return-value="id"
								@input="fieldGroupInputHandler"
							/>

							<ui-select-2
								v-model="groupFieldSelected"
								:loading="groupFieldLoading"
								:disabled="!groupFieldOptionsComputed.length"
								:data="groupFieldOptionsComputed"
								label="Campo:"
								item-label="name"
								return-value="id"
							/>
						<template #footer>
							<ui-button
								:disabled="!canAddCustomField"
								type="button" 
								design="md primary mw-100" 
								@click="addCustomField"
							>
								Adicionar
							</ui-button>
						</template>
					</ui-popup>

					<section class="ui-repeater" v-show="customFieldsComputed.length">
						<div class="items">
							<div v-for="field in customFieldsComputed"
								:key="field.key"
								class="item">
								<div class="custom-fields">
									<ui-select-2 v-model="form.custom_fields[field.key]"
										:data="options"
										:label="field.label + ':'"
										multiple
										return-value="value"
										size="md" />
										<div class="trash">
											<button typpe="button" @click="deleteCustomField(field.key)"><i class="far fa-trash-alt"></i></button>
										</div>
								</div>
							</div>
						</div>	
						<section class="control" v-show="customFieldsComputed.length">
							<div>
								<button type="button" @click="addFields()" >
									<i class="fal fa-plus"></i>
								</button>
							</div>
							<div>Adicionar outro campo</div>
						</section>
					</section>
				</section>
			</section>

			<section data-content data-title="Etapa e Status do Funil" data-id="funnel-stage-status">
				<section class="sidebar-content">
					<h2>1 - Etapa e Status no Funil:</h2>
					<ui-select-tags v-model="form.extra_fields.deal.product_id"
						:options="productOptions"
						:limit="1"
						:load="productLoading"
						remove-selected-item
						label="Selecione o empreendimento:"
						class="mb-10"
						size="md"/>

					<ui-select-2
						v-model="form.extra_fields.deal.funnel_stage_id"
						:loading="funnelStageLoading"
						:data="funnelStageOptions"
						label="Selecione a Etapa:"
						item-label="name"
						return-value="id"
						@input="stageInputHandler"
					/>

					<ui-select-2
						v-model="form.extra_fields.deal.funnel_stage_status_id"
						:loading="funnelStageStatusLoading"
						:data="funnelStageStatusOptions"
						:disabled="desabledStatusCondition"
						label="Selecione o Status:"
						item-label="name"
						return-value="id"
					/>
				</section>
			</section>

			<section data-content data-title="Distribuição de Leads" data-id="leads-distribution">
				<section class="sidebar-content">
					<h2>1 - Enviar os leads para fila:</h2>
					<ui-select-2
						v-model="form.leads_id"
						:loading="leadLoading"
						:data="leadOptions"
						label="Selecione uma Fila:"
						item-label="name"
						return-value="id"
					/>
				</section>
			</section>

			<section data-content data-title="Outras Configurações" data-id="other-configurations">
				<section class="sidebar-content">
					<h2>1 - Identificação do Formulário</h2>
					<ui-input v-model="form.name"
						type="text"
						label="Digite o nome do Formulário:"
						size="md"/>
				</section>
			</section>
		</form>
		<template #footer>
			<ui-button
				:disabled="!canSubmit"
				type="button" 
				design="lg success block" 
				@click="submitForm"
			>
				Salvar alterações
			</ui-button>
		</template>
	</ui-sidebar-float>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'
	import { uiSidebarFloat, uiPopup } from '@/components/ui'
	import { uiSelectTags, uiSelect2, uiInput } from '@/components/ui/form'
	import { mapGetters } from 'vuex'
	import { formTracker, product, funnel, lead } from '@/services/axios'
	import store from '@/store'
	import axios from 'axios'

	/** Objeto com os dados padrões de um objeto do tipo form tracker */
	const defaultFormData = () => {
		return {
			id: null,
			name: '',
			configured: 'yes',
			leads_id: null,
			custom_fields: {},
			extra_fields: {
				deal: {
					funnel_stage_id: null,
					funnel_stage_status_id: null,
					product_id: null
				}
			},
			map_fields: {
				customer: {
					name: [],
					email: [],
					phone: [],
					mobile: [],
					cpf: [],
					message: [],
				},
				deal: {
					observations: []
				}
			}
		}
	}

	export default {
		components: {
			uiButton,
			uiSidebarFloat,
			uiSelectTags,
			uiSelect2,
			uiInput,
			uiPopup,
		},
		data(){
			return {
				form: defaultFormData(),
				options: [],
				message: '',
				optionsLoading: false,
				productOptions: [],
				productLoading: false,
				funnelStageOptions: [],
				funnelStageLoading: false,
				funnelStageStatusOptions: [],
				funnelStageStatusLoading: false,
				fieldGroupOptions: [],
				fieldGroupSelected: null,
				fieldGroupLoading: false,
				groupFieldOptions: [],
				groupFieldLoading: false,
				groupFieldSelected: null,
				leadOptions: [],
				leadLoading: false,
				unsubscribe: null,
				loadText: null
			}
		},
		computed: {
			...mapGetters('formTracker', {
				sidebarConfig: 'getSidebarConfig'
			}),
			/**
			 * Computed property para a geração e manipulação dos campos dinâmicos
			 */
			customFieldsComputed: {
				set(value) {
					let customFields = { ...this.form.custom_fields }
					this.$set(customFields, `${value.field_group_id}_${value.field_id}`, null)
					this.form.custom_fields = { ...customFields }
				},
				get() {
					let customFields = []
					for (let custom in this.form.custom_fields) {
						let split = custom.split('_')
						let groupId = split[0]
						let fieldId = split[1]
						let group = this.fieldGroupOptions.find(group => group.id === parseInt(groupId))
						let label = group.name + ' - ' + group.fields.find(field => field.id === parseInt(fieldId)).name
						customFields.push({
							key: custom,
							label,
							value: this.form.custom_fields[custom]
						})
					}
					return customFields
				}
			},
			/**
			 * Computed property para manipular os grupos dinâmicos de modo
			 * a não mostrar um campo de um grupo quando este já estiver sendo
			 * utilizado em um campo dinâmico
			 */
			groupFieldOptionsComputed: {
				get() {
					let fieldOptions = Object.values(this.groupFieldOptions).filter(field => {
						return typeof this.form.custom_fields[`${this.fieldGroupSelected}_${field.id}`] === 'undefined'
					})
					
					return fieldOptions
				}
			},
			
			desabledStatusCondition() {
				return (
					!this.funnelStageOptions.length ||
					!this.funnelStageStatusOptions.length
				)
			},

			hasStatusListAndIsSelected() {
				return (
					this.funnelStageStatusOptions.length && this.hasValue(this.form.extra_fields.deal.funnel_stage_status_id)
				)
			},

			notHasStatusListAndIsNotSelected() {
				return (
					!this.funnelStageStatusOptions.length &&
					!this.hasValue(this.form.extra_fields.deal.funnel_stage_status_id)
				)
			},

			canSubmit() {
				return (
					this.hasValue(this.form.leads_id) &&
					(!this.hasValue(this.form.extra_fields.deal.funnel_stage_id) ||
						(this.hasValue(this.form.extra_fields.deal.funnel_stage_id) &&
							(this.hasStatusListAndIsSelected ||
								this.notHasStatusListAndIsNotSelected)))
				)
			},
			canAddCustomField() {
				return (
					this.hasValue(this.groupFieldSelected) &&
					this.hasValue(this.fieldGroupSelected)
				)
			}
		},

		created() {
			/** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
				/** Atualiza o conteúdo da sidebar */
                if (mutation.type === 'formTracker/SET_SIDEBAR_CONFIG') {
					this.getSidebarConfig()
				}
			})
			
			/** Cancela todas as requisições que monta o formulário quando o usuário fechar o sidebar */
			this.$root.$on('sidebar-close-form-tracker-config', () => {
				store.getters.formTrackerCancel.cancel()
			})
        },
        beforeDestroy() {	
            /** Desubscreve para a mutation */
            this.unsubscribe()
        },
		methods: {

			hasValue(value) {
				if (value == null || value.length == 0) return false
				if (value) return true
				return false
			},
			/**
			 * Abre o modal com o formulário de criação dos campos dinâmicos
			 */
			addFields(){
				this.$root.$emit('popup-open-add-fields')
			},
			/**
			 * Limpa os dados do formulário e inicializa com os valores padrões
			 */
			clearForm () {
				this.form = { ...defaultFormData() }
				this.message = ''
				this.options = []
				this.optionsLoading = false
				this.productOptions = []
				this.productLoading = false
				this.funnelStageOptions = []
				this.funnelStageLoading = false
				this.funnelStageStatusOptions = []
				this.funnelStageStatusLoading = false
				this.fieldGroupOptions = []
				this.fieldGroupSelected = null
				this.fieldGroupLoading = false
				this.groupFieldOptions = []
				this.groupFieldLoading = false
				this.groupFieldSelected = null
				this.leadOptions = []
				this.leadLoading = false
			},
			/**
			 * Aciona o carregamento dos dados do formulário de acordo com o ID
			 * do form tracker que foi passado
			 */
			getSidebarConfig() {
				this.clearForm()

				if (this.sidebarConfig && typeof this.sidebarConfig.id !== 'undefined') {
					this.form.id = this.sidebarConfig.id
					this.loadForm()
				} else {
					this.form.id = null
					this.$root.$emit('sidebar-close-form-tracker-config')
					this.$toastr.e('Informações do FormTracker não definidas.')
				}
			},
			/**
			 * Carrega os dados do form tracker no formulário
			 */
			setForm(response) {
				this.options = [...response.data.last_send]
				this.productOptions = [...response.data.product_options, ...this.productOptions]
				this.form.map_fields = { ...response.data.map_fields }
				this.form.extra_fields = { ...response.data.extra_fields }
				this.form.custom_fields = { ...response.data.custom_fields }
				this.form.name = response.data.name
				this.form.leads_id = response.data.leads_id
				this.loadStageStatusOptions(this.form.extra_fields.deal.funnel_stage_id)
			},
			/**
			 * Carrega os dados do formulário
			 */
			async loadForm() {
				this.optionsLoading = true
				this.productLoading = true
				this.funnelStageLoading = true
				this.fieldGroupLoading = true
				this.leadLoading = true
				this.loadText = 'Carregando configurações'

				/** Gera o token para cancelar as requisições */
				const CancelToken = axios.CancelToken
				const source = CancelToken.source()
				store.dispatch('formTracker/setLoadCancel', source)
				const config = {
					cancelToken: source.token
				}

				await product.getProductOptions(config)
					.then(response => {
						let items = response.data.map((data) => {
							return { label: data.label, value: data.value }
						});
						this.productOptions = [{
							title                 : "Empreendimentos do sistema",
							items                 : [...items],
						},];

						this.productLoading = false
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						this.productLoading = false
					})

				await funnel.getStages(config)
					.then(response => {
						this.funnelStageOptions = [...response.data]
						this.funnelStageLoading = false
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						this.funnelStageLoading = false
					})
				
				await funnel.getFieldGroups(config)
					.then(response => {
						this.fieldGroupOptions = [...response.data]
						this.fieldGroupLoading = false
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						this.fieldGroupLoading = false
					})
				
				await lead.getAll('', {}, config)
					.then(response => {
						this.leadOptions = [...response.data]
						this.leadLoading = false
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						this.leadLoading = false
					})

				await formTracker.get(this.form.id, config)
					.then(response => {
						this.setForm(response)
						this.optionsLoading = false
						this.productLoading = false
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						this.optionsLoading = false
					})
			},
			/**
			 * Envia os dados do formulário de modo a atualizar a instância
			 */
			submitForm() {
				if (this.canSubmit) {
					this.optionsLoading = true					
					this.productLoading = true
					this.loadText = 'Salvando alterações'
					formTracker.update(this.form.id, this.form)
						.then(response => {
							/** Remove o grupo de dados do select que contém os produtos do formulário */
							this.productOptions.splice(0, 1)
							this.setForm(response.data)
							this.optionsLoading = false
							this.productLoading = false
							// fechar sidebar
							setTimeout(() => {
								this.$children[0].close()
							}, 500)
							this.$root.$emit('datatable-reload-formtracker')
						})
						.catch(error => {
							if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
							this.optionsLoading = false
							this.productLoading = false
						})
				} else {
					this.message = 'É necessário selecionar uma fila de leads.'
					this.$refs['form-tracker-config'].$emit('tab-content', 'leads-distribution')
				}		
			},
			/**
			 * Carrega o select de status de acordo com a etapa selecionada
			 */
			loadStageStatusOptions(stageId) {
				this.funnelStageStatusLoading = true
				this.funnelStageStatusOptions = []
				let stage = Object.values(this.funnelStageOptions).find(stage =>  stage.id === parseInt(stageId))
				if (stage) this.funnelStageStatusOptions = [...stage.status]
				this.funnelStageStatusLoading = false
			},
			/**
			 * Função chamada quando uma etapa é selecionada
			 */
			stageInputHandler(stageId) {
				this.form.extra_fields.deal.funnel_stage_status_id = null
				this.loadStageStatusOptions(stageId)
			},
			/**
			 * Carrega select de campos de acordo com o grupo de campos selecionado
			 */
			loadGroupFieldOptions(groupId) {
				this.groupFieldLoading = true
				this.groupFieldOptions = []
				let group = Object.values(this.fieldGroupOptions).find(group =>  group.id === parseInt(groupId))
				if (group) this.groupFieldOptions = [...group.fields]
				this.groupFieldLoading = false
			},
			/**
			 * Função chamada quando um grupo de campos é selecionado
			 */
			fieldGroupInputHandler(groupId) {
				this.groupFieldSelected = null
				this.loadGroupFieldOptions(groupId)
			},
			/**
			 * Adiciona um novo campo dinâmico de acordo com o grupo de campos e
			 * campo selecionado
			 */
			addCustomField() {
				if (this.canAddCustomField) {
					this.customFieldsComputed = {
						field_group_id: this.fieldGroupSelected,
						field_id: this.groupFieldSelected
					}
					this.fieldGroupSelected = null

					this.fieldGroupInputHandler(null)
					this.$root.$emit('popup-close-add-fields')
				}
			},
			/**
			 * Remove um campo dinâmico
			 */
			deleteCustomField(key) {
				this.$delete(this.form.custom_fields, key)
			}
		}
	}
</script>
